import { LogEventType } from '@akin-home/amplify';
import { PageViewLogEvent } from '@akin-home/logging';
import { postLogEvent, PostLogEventParams } from './postLogEvent';

type Params = Omit<PostLogEventParams<PageViewLogEvent['data']>, 'type'>;

export const postPageViewLogEvent = (params: Params) =>
  postLogEvent({
    type: LogEventType.PAGE_VIEW,
    ...params,
  });
